import { TCardInputError } from '@libs/types';

export type TErrorCardInputResult = {
    cardNumber?: TCardInputError;
    expDate?: TCardInputError;
    card?: TCardInputError;
};
export type TCard = {
    iconName?: string;
    avatar?: string;
    bankTitle: string;
    paymentSystemIcon?: string;
    isVisualEnabled: boolean;
    isShowPaymentSystem: boolean;
};
export enum EName {
    CARD_NUMBER = 'cardNumber',
    EXP_DATE = 'expDate',
}
export enum EActionName {
    getCardInfo = 'GetCardInfo',
}
